import React, { type FC } from 'react';
import classnames from 'classnames';
import styles from './Poll.module.css';
import { type IPollChoice, type IPollQuestion } from './records';

interface Props {
  question: IPollQuestion;
  selectedChoiceId?: string;
  onSelectChoice: (choice: IPollChoice) => void;
}

const NumberScale: FC<Props> = ({
  question,
  selectedChoiceId,
  onSelectChoice,
}) => {
  return (
    <>
      <div className={styles.numberScale}>
        {question.choices
          .map((choice: IPollChoice, index: number) => (
            <div
              key={choice.id || index}
              onClick={() => onSelectChoice(choice)}
              onTouchStart={() => onSelectChoice(choice)}
              className={classnames(styles.number, {
                [styles.numberSelected]: selectedChoiceId === choice.id,
              })}
            >
              {index + 1}
            </div>
          ))
          .toArray()}
      </div>
      <div className={`${styles.labels} ${styles.numberScaleLabels}`}>
        <span className={styles.lowLabel}>{question.low_label}</span>
        <span className={styles.highLabel}>{question.high_label}</span>
      </div>
    </>
  );
};

export default NumberScale;
